
<template>
  <div class="buyServiceSuccess">
    <my-dialog :class-name="'unlogin-buy-service-success-dialog'" :width="530" v-model="show" :ok-btn="false" @cancel="cancel" title="">
      <div class="success-txt">
        <p class="icon"><i class="iconfont icon-gou"></i></p>
        <p class="p1">感谢您对猎上的支持！</p>
        <p class="p2">我们将在1个工作日内与您联系，如有紧急需求，可以联系<span>客服经理{{serviceUser.name}}</span>。</p>
      </div>
      <div class="success-tip">
        <p class="t-txt">电话：{{serviceUser.telePhone}}</p>
        <p class="t-txt">手机：{{serviceUser.mobilePhone}}</p>
        <p class="t-txt">邮箱：<a :href="'mailto:'+serviceUser.email">{{serviceUser.email}}</a></p>
      </div>
    </my-dialog>
  </div>
</template>

<script>
import myDialog from "@/components/myDialog";

export default {
  name: "buyServiceSuccess",
  props: ["serviceUser"],
  data() {
    return {
      show: true
    };
  },
  components: { myDialog },
  methods: {
    ok() {},
    cancel() {
      this.show = false;
      this.$emit("input", this.show);
    }
  },
  created() {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.success-txt {
  .icon-gou {
    font-size: 68px;
    color: #2ea1f8;
  }
  .icon {
    margin: -15px auto 0;
  }
  text-align: center;
  .p1 {
    font-size: 18px;
    color: #393a41;
    margin-bottom: 15px;
  }
  .p2 {
    font-size: 14px;
    color: #656675;
    line-height: 24px;
    margin-bottom: 25px;
    span {
      color: #2ea1f8;
    }
  }
}
.success-tip {
  margin-bottom: 10px;
  .t-txt {
    margin: 8px 0 0 145px;
    font-size: 14px;
    color: #393a41;
    a {
      color: #393a41;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/unloginBuyServiceSuccess.vue